import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import _ from "lodash";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import { TokenService } from './services/token.service';
import { KeycloakService } from './services/keycloak.service'
import Keycloak from 'keycloak-js'
import VTooltip from "v-tooltip";
import VueRouterReferer from '@tozd/vue-router-referer';
import VCalendar from 'v-calendar'

const keycloakConfig = KeycloakService.getConfig()
const initOptions = KeycloakService.getInitOptions()
const keycloak = new Keycloak(keycloakConfig)

const params = new URL(document.location.toString()).searchParams;
const location = params.get("location") != undefined ? params.get("location") : undefined

keycloak.init(initOptions).then((auth) =>{

    if(!auth) {
      window.location.reload();
    }

    TokenService.storeToken(keycloak.token)
    TokenService.storeRefreshToken(keycloak.refreshToken)
    KeycloakService.setKeycloak(keycloak, () => {
      Vue.use(VueMoment, {
        moment,
      })

      Vue.prototype.$_ = _;

      Vue.config.productionTip = false

      Vue.use(VTooltip)
      Vue.use(VCalendar)
      Vue.use(VueRouterReferer)
      Vue.config.productionTip = false

      new Vue({
        router,
        store,
        render: h => h(App, {
          props: {
            given_location: location
          }
        })
      }).$mount('#app')


      setInterval(() =>{
        keycloak.updateToken(70).then((refreshed)=>{
          if (refreshed) {
            // console.log('Token refreshed'+ refreshed);
            TokenService.storeToken(keycloak.token)
          } else {
            // console.log('Token not refreshed, valid for '
            // + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          }
        }).catch(()=>{
            // console.log('Failed to refresh token')
        });
      }, process.env.VUE_APP_KEYCLOAK_REFRESH)

  })

}).catch(() =>{

    // console.log('Authentication Failed')

})
